import { Route } from '@angular/router';
import { AuthenticationGuard } from '../access/shared/authentication/authentication-guard';
import { AuthorizationGuardService } from '../access/shared/authorization/authorization-guard.service';
import { BasketRouting } from './basket/basket-routing';
import { BillingRouting } from './billing/billing-routing';
import { BordereauxRouting } from './bordereaux/bordereaux-routing';
import { ContactUsRouting } from './contact-us/contact-us.routing';
import { CustomerAreaComponent } from './customer-area.component';
import { DailyOperationRouting } from './daily-operation/daily-operation-routing';
import { DavRouting } from './dav/dav-routing';
import { DeliveryRouting } from './delivery/delivery-routing';
import { HomePageRouting } from './home-page/home-page-routing';
import { LectureCabRouting } from './lecture-cab/lecture-cab-routing';
import { LingeHebergementRouting } from './linge-hebergement/linge-hebergement-routing';
import { MentionsLegalesRouting } from './mentions-legales/mentions-legales-routing';
import { OrderTrackingRouting } from './order/order-tracking-routing';
import { ProfileRouting } from './profile/profile-routing';
import { CommandeParamRouting } from './settings/commande-param/commande-param-routing';
import { DavParamRouting } from './settings/dav-param/dav-param-routing';
import { UserRouting } from './settings/user/user-routing';
import { StatisticRouting } from './statistic/statistic-routing';

export const CustomerAreaRoutes: Route = {
    path: 'escli',
    component: CustomerAreaComponent,
    canActivate: [AuthenticationGuard],
    canActivateChild: [AuthorizationGuardService],
    children: [
        HomePageRouting,
        BillingRouting,
        DailyOperationRouting,
        DeliveryRouting,
        OrderTrackingRouting,
        UserRouting,
        ProfileRouting,
        StatisticRouting,
        ContactUsRouting,
        BasketRouting,
        LectureCabRouting,
        LingeHebergementRouting,
        CommandeParamRouting,
        DavParamRouting,
        DavRouting,
        BordereauxRouting,
        MentionsLegalesRouting
    ],
    data: {
        breadcrumb: "Espace Client"
    }
}
